import emailAddressValidation from '@/services/validation/email-address/index';
import coordinatesValidation from '@/services/validation/coordinates/index';

export default {
  emailAddressValidation,
  coordinatesValidation,
};
